import TransferInvitationContext from '@cohort/wallet/components/contexts/TransferInvitationContext';
import {Spinner} from '@cohort/wallet/components/Spinner';
import {useInvitationById} from '@cohort/wallet/hooks/api/Invitations';
import {Colors} from '@cohort/wallet/lib/Theme';
import {useNavigate, useParams} from 'react-router-dom';

type TransferInvitationContextProviderProps = {
  children: React.ReactNode;
};

const TransferInvitationContextProvider: React.FC<TransferInvitationContextProviderProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const {invitationId} = useParams();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const {data: invitation, isFetched} = useInvitationById(invitationId!, !!invitationId);

  if (!invitationId || (isFetched && !invitation)) {
    navigate('/space/not-found', {replace: true});
  }

  if (invitation === undefined) {
    return (
      <div className="my-auto flex h-screen w-full items-center justify-center">
        <Spinner color={Colors.Black} height="h-6" width="w-6" />
      </div>
    );
  }

  return (
    <TransferInvitationContext.Provider value={invitation}>
      {children}
    </TransferInvitationContext.Provider>
  );
};

export default TransferInvitationContextProvider;
